import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface BankAccountsCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export function BankAccountsCardThumbnail({ isHovered = false, alwaysVisible = false }: BankAccountsCardThumbnailProps) {
  // When always visible, show at 40% scale. When hover-only, show at 100% scale (or 2.5x on hover)
  const baseScale = alwaysVisible ? 'scale-[0.4]' : 'scale-100';
  const scale = isHovered ? 'scale-100' : baseScale;
  const zIndex = isHovered ? 'z-50' : 'z-0';
  
  return (
    <div className={`transition-all duration-300 ${scale} ${zIndex} origin-left`}>
      <Card className="w-[300px] border shadow-sm bg-background">
        <CardHeader className="px-3 pt-3 pb-2">
          <CardTitle className="text-[10px] font-medium">Bank Accounts</CardTitle>
        </CardHeader>
        <CardContent className="px-3 pb-3">
          <div className="space-y-1.5">
            {/* Account 1 */}
            <div className="flex items-center justify-between p-1.5 border rounded text-[8px]">
              <div>
                <div className="font-medium">Main Current</div>
                <div className="text-muted-foreground">HSBC</div>
              </div>
              <div className="text-right">
                <div className="text-[10px] font-bold">£145,230</div>
                <Badge variant="outline" className="text-[7px] h-3 px-1">GBP</Badge>
              </div>
            </div>
            
            {/* Account 2 */}
            <div className="flex items-center justify-between p-1.5 border rounded text-[8px]">
              <div>
                <div className="font-medium">Reserve Account</div>
                <div className="text-muted-foreground">Barclays</div>
              </div>
              <div className="text-right">
                <div className="text-[10px] font-bold">£98,720</div>
                <Badge variant="outline" className="text-[7px] h-3 px-1">GBP</Badge>
              </div>
            </div>
            
            {/* Account 3 */}
            <div className="flex items-center justify-between p-1.5 border rounded text-[8px]">
              <div>
                <div className="font-medium">Payroll Account</div>
                <div className="text-muted-foreground">Lloyds</div>
              </div>
              <div className="text-right">
                <div className="text-[10px] font-bold">£43,500</div>
                <Badge variant="outline" className="text-[7px] h-3 px-1">GBP</Badge>
              </div>
            </div>
            
            {/* Total */}
            <div className="flex items-center justify-between p-1.5 bg-primary/10 rounded font-semibold text-[8px]">
              <div>Total Cash</div>
              <div className="text-[11px]">£287,450</div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
